import styled, { css } from "styled-components"
import { TextLink } from "../../../../../ui/components/link/link.component"
import { PrimaryHeading, SecondaryHeading } from "../../../heading.component"
import Section, { SectionArticle } from "../../section.component"
import ColorSelectRadioUI, {
  ColorRadioButton,
  ColorWrapper,
} from "../../../../commerce/color-select-radio/color-select-radio-ui.component"

export const MomentSection = styled(Section)`
  grid-template-columns: 400px 1fr;
  grid-template-rows: 55px auto auto;
  grid-template-areas:
    "Image Heading"
    "Image Description"
    "Image Article"
    "Image WatchName";
  grid-column-gap: 70px;
  padding: 70px 0px;

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
  }

  @media (max-width: 840px) {
    padding: 0;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      "Heading"
      "Description"
      "Image"
      "WatchName"
      "Article";
    align-items: center;
    justify-content: center;
  }

  ${SectionArticle} {
    @media (min-width: 1160px) {
      padding-right: 0px;
    }
  }

  ${PrimaryHeading} {
    @media (max-width: 840px) {
      justify-self: center;
    }
    @media (max-width: ${({ theme }) => theme.breakpoint.mobileSmall + 1}px) {
      padding: 0 10px;
      text-align: center;
    }
  }
  ${SecondaryHeading} {
    @media (max-width: 840px) {
      justify-self: center;
    }
    @media (max-width: ${({ theme }) => theme.breakpoint.mobileSmall + 1}px) {
      padding: 0 10px;
      text-align: center;
    }
  }
`

export const MomentImage = styled.img<{ active?: boolean }>`
  display: ${({ active }) => (active ? "inherit" : "none")};
  grid-area: Image;
  max-width: 400px;
  max-height: auto;

  @media (max-width: 840px) {
    height: 375px;
    width: 375px;
    object-fit: cover;
    justify-self: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileSmall}px) {
    height: 320px;
    width: 320px;
  }
`

export const MomentArticle = styled(SectionArticle)`
  padding: 0;
  align-self: flex-start;

  ${PrimaryHeading} {
    grid-area: Heading;
    margin-bottom: 0;
    &:first-child {
      margin-top: 0;
    }
  }

  span {
    margin-bottom: 15px;
  }

  @media (max-width: 840px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    min-width: 350px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileSmall}px) {
    min-width: 320px;
  }
`

export const MomentColorRadio = styled(ColorSelectRadioUI)`
  &${ColorWrapper} {
    flex-wrap: wrap;

    @media (max-width: 840px) {
      flex-wrap: nowrap;
      overflow-x: scroll;
    }
  }

  ${ColorRadioButton} {
    --color-input-size: 70px;
    --space-between: 15px;

    @media (min-width: 840px) {
      --color-input-size: 90px;
    }
  }
`

export const Dials = styled.div<{ displayDials?: boolean }>`
  margin-top: 50px;
  margin-bottom: 30px;

  @media (max-width: 840px) {
    display: ${({ displayDials }) => (displayDials ? "block" : "none")};
    margin-top: 30px;
    margin-bottom: 0px;
    max-width: 345px;
    width: 100%;
    height: 103px;
    justify-self: center;
  }
`

export const Straps = styled.div<{ displayStraps?: boolean }>`
  @media (max-width: 840px) {
    display: ${({ displayStraps }) => (displayStraps ? "block" : "none")};
    margin-top: 30px;
    max-width: 345px;
    height: 103px;
    width: 100%;
  }
`

export const SwitchWrapper = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;

  ${({ active }) =>
    active !== undefined &&
    css`
      display: ${active ? "flex" : "none"};
    `}

  @media (max-width: 840px) {
    margin-bottom: 16px;
  }

  @media (min-width: 840px) {
    display: none;
  }
`

export const DialsSwitch = styled(TextLink)``

export const StrapsSwitch = styled(TextLink)``

export const WatchNameHeading = styled(SecondaryHeading)<{ active?: boolean }>`
  display: ${({ active }) => (active ? "block" : "none")};
  grid-area: WatchName;
  font-weight: normal;

  @media (max-width: 840px) {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  @media (min-width: 1200px) {
    margin-top: 0px;
  }
`

export const ModuleDescription = styled(SectionArticle)`
  grid-area: Description;
`
